import { observable, action } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { withRole } from '@src/utils/residentNew';
import { PositionFilterOption } from '@src/utils/constant';
import { IMenuData } from '@src/entity/user';

interface ICity {
  id: number;
  name: string;
  level: number;
  children?: ICity[];
  parent: number;
}

export interface INameIdProp {
  id: number | undefined;
  name: string;
  min_salary?: number;
  max_salary?: number;
}

export interface IPositionFilterGroup {
  label: string;
  value: PositionFilterOption;
  children: INameIdProp[];
}

interface IBaseData {
  // 技术方向
  technicalDirection: INameIdProp[];
  // 薪资范围
  expectedSalary: INameIdProp[];
  // 学历
  educationRequirements: INameIdProp[];
  // 工作年限
  workingYears: INameIdProp[];
  // 发布日期
  releaseDate: INameIdProp[];
  // 是否支持远程面试
  remoteInterview: INameIdProp[];
  // 驻场周期
  residentPeriod: INameIdProp[];
  // 是否可续签
  renewal: INameIdProp[];
  // 职位类型
  offerProp: INameIdProp[];
}

class User {
  constructor() {}

  // 基础数据
  @observable
  baseData: IBaseData = {
    expectedSalary: [],
    technicalDirection: [],
    educationRequirements: [],
    workingYears: [],
    releaseDate: [],
    remoteInterview: [],
    residentPeriod: [],
    renewal: [],
    offerProp: []
  };
  @observable fetchingBasicData: string = 'init';
  // 城市数据
  @observable
  baseCityList: IMenuData[] = [
    {
      value: -2,
      label: '全国',
      children: [
        {
          value: -1,
          label: '全国'
        }
      ]
    }
  ];
  @observable fetchingCityList: string = 'init';

  // 储存公用常量数据
  @action.bound
  async getBasicData() {
    this.fetchingBasicData = 'pending';
    const res = await ajax.getJson('/mresident/api/params', withRole({}, 2));

    if (res.error_code === 0) {
      this.fetchingBasicData = 'done';
      const {
        renewal,
        expected_salary,
        technical_direction,
        education_requirements,
        working_years,
        release_date,
        remote_interview,
        resident_period,
        offer_prop
      } = res.params;
      this.baseData = {
        expectedSalary: expected_salary,
        technicalDirection: technical_direction,
        educationRequirements: education_requirements.filter(v => v.name && !['MBA', 'EMBA'].includes(v.name)),
        workingYears: working_years,
        releaseDate: release_date,
        remoteInterview: remote_interview,
        residentPeriod: resident_period,
        renewal,
        offerProp: offer_prop
      };
    } else {
      this.fetchingBasicData = 'error';
    }
  }

  // 获取城市数据
  @action.bound
  async getCity() {
    this.fetchingCityList = 'pending';
    const res = await ajax.getJson('/zhaopin/api/citys', withRole({}, 2));
    if (res.error_code === 0) {
      this.fetchingCityList = 'done';
      this.baseCityList = [
        {
          value: -2,
          label: '全国',
          children: [
            {
              value: -1,
              label: '全国'
            }
          ]
        },
        ...cityData2MenuData(res.citys)
      ];
    } else {
      this.fetchingCityList = 'error';
    }
  }
}

export default User;

function cityData2MenuData(cityData: ICity[]) {
  let res: IMenuData[] = [];
  cityData.forEach(city => {
    const data: IMenuData = {
      value: city.id,
      label: city.name
    };
    if (city.children) {
      data.children = cityData2MenuData(city.children);
    }
    res.push(data);
  });
  return res;
}
